import { useLocation, useSearchParams } from 'react-router-dom';

// ============================================================
// Shell v2 — nome da tela na Faixa 1 do header.
// Regra Douglas "1 informação, 1 lugar": navegação fica SÓ na
// sidebar (a Faixa 2 com abas duplicadas foi removida em 13/07).
// Para rotas com ?tab=, o nome mostrado é o da ABA ativa.
// ============================================================

/** Nome da tela por rota. */
const ROUTE_TITLES: Record<string, string> = {
  '/dashboards': 'Dashboards',
  '/whatsapp-inbox': 'WhatsApp Inbox',
  '/conexoes-whatsapp': 'Conexões WhatsApp',
  '/discadora': 'Discadora',
  '/comercial': 'Comercial',
  '/planilha': 'Planilha',
  '/kanban': 'Kanban',
  '/kanbans': 'Kanban',
  '/bora-fazer': 'Bora Fazer',
  '/carteira': 'Carteira',
  '/carteira-clientes': 'Carteira',
  '/consulta-rapida-lead': 'Consulta Rápida',
  '/visao-comissoes': 'Produtividade',
  '/mailing-diarios': 'Mailing',
  '/cobertura': 'Cobertura',
  '/consulta-operadora': 'Consulta Operadora',
  '/ecossistema-api': 'Ecossistema API',
  '/email-marketing': 'Disparos',
  '/controle-diario': 'Controle Diário',
  '/performance-leads': 'Performance Leads',
  '/conecta-ia': 'Conecta IA',
  '/ciclo-faturas': 'Ciclo de Faturas',
  '/rh': 'RH e Departamento Pessoal',
  '/avisos': 'Avisos',
  '/regras-comissao': 'Regras Produtividade',
  '/usuarios': 'Usuários',
  '/equipes': 'Equipes',
  '/configuracoes': 'Configurações',
  '/meu-perfil': 'Meu Perfil',
  '/minha-performance': 'Minha Performance',
  '/venda-diaria': 'Venda Diária',
};

/** Nome por aba (?tab=) nas telas-mãe — mostra a tela específica, não o módulo. */
const TAB_TITLES: Record<string, Record<string, string>> = {
  '/dashboards': {
    gerencial: 'Ranking',
    'visao-prime': 'Visão Prime',
    'visao-conecta': 'Visão Conecta',
    slas: 'Backoffice Prime',
    metas: 'Metas',
    'venda-diaria': 'Venda Diária',
  },
  '/comercial': {
    prospeccao: 'Leads',
    'gestao-leads': 'Gestão de Leads',
    cliques: 'Click',
    carteira: 'Carteira de Clientes',
    faturas: 'Faturas',
    'fatura-manual': 'Fatura Manual',
    agendas: 'Agendas',
    analytics: 'Analytics Leads',
    'master-leads': 'Central de Importações',
  },
  '/rh': {
    guia: 'Guia do RH',
    semana: 'Semana do RH',
    pessoas: 'Colaboradores',
    regularizacao: 'Regularização do RH',
    admissao: 'Admissão',
    linha: 'Linha do RH',
    ponto: 'Ponto & Jornada',
    rotinas: 'Rotinas do RH',
    aniversarios: 'Aniversários',
    avatar: 'Avatar',
    artes: 'Artes',
    ferias: 'Férias',
    simulador: 'Simulador',
    manual: 'Manual Prime',
  },
};

const TAB_DEFAULTS: Record<string, string> = {
  '/dashboards': 'gerencial',
  '/comercial': 'prospeccao',
  '/rh': 'semana',
};

export function useShellScreenTitle(): string | null {
  const { pathname } = useLocation();
  const [searchParams] = useSearchParams();

  const tabMap = TAB_TITLES[pathname];
  if (tabMap) {
    const tab = searchParams.get('tab') || TAB_DEFAULTS[pathname] || '';
    if (tabMap[tab]) return tabMap[tab];
  }

  if (ROUTE_TITLES[pathname]) return ROUTE_TITLES[pathname];
  const base = '/' + (pathname.split('/')[1] || '');
  return ROUTE_TITLES[base] || null;
}
